export const RATE_MAX_DECIMALS = 6;
export const RATE_ROUNDING_MODE = 'half-even';

export const normalizeRateToPrecision = (value: number, decimals: number = RATE_MAX_DECIMALS): number => {
  if (!Number.isFinite(value)) {
    return value;
  }

  const factor = 10 ** decimals;
  const scaled = value * factor;
  const floor = Math.floor(scaled);
  const diff = scaled - floor;

  if (diff > 0.5) {
    return (floor + 1) / factor;
  }

  if (diff < 0.5) {
    return floor / factor;
  }

  const rounded = floor % 2 === 0 ? floor : floor + 1;
  return rounded / factor;
};